/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Contactusforanyfurthe4Inputs */

const en_help_contactusforanyfurthe4 = /** @type {(inputs: Help_Contactusforanyfurthe4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us for any further question or suggestions you have`)
};

/**
* | output |
* | --- |
* | "Contact us for any further question or suggestions you have" |
*
* @param {Help_Contactusforanyfurthe4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_contactusforanyfurthe4 = /** @type {((inputs?: Help_Contactusforanyfurthe4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Contactusforanyfurthe4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_contactusforanyfurthe4(inputs)
});
export { help_contactusforanyfurthe4 as "help_contactUsForAnyFurthe" }